export function normalizePlatform(value) {
    const platform = String(value || "").trim().toLowerCase();
    if (platform === "ios" || platform === "android") {
        return platform;
    }
    return null;
}
export function parseVersion(value) {
    if (!value)
        return [0];
    return String(value)
        .split(".")
        .map((item) => Number(String(item).replace(/\D/g, "")) || 0);
}
export function isVersionLess(current, target) {
    const currentVersion = parseVersion(current);
    const targetVersion = parseVersion(target);
    const maxLength = Math.max(currentVersion.length, targetVersion.length);
    for (let index = 0; index < maxLength; index += 1) {
        const left = currentVersion[index] ?? 0;
        const right = targetVersion[index] ?? 0;
        if (left < right)
            return true;
        if (left > right)
            return false;
    }
    return false;
}
export function getVersionFromDevice(device) {
    return trimNullable(device?.expoVersion) || trimNullable(device?.versionApp) || trimNullable(device?.version);
}
export function trimNullable(value) {
    const normalized = String(value || "").trim();
    return normalized || null;
}
export function normalizePolicy(platform, source) {
    return {
        platform,
        enabled: Boolean(source?.enabled),
        minSupportedVersion: trimNullable(source?.minSupportedVersion),
        recommendedVersion: trimNullable(source?.recommendedVersion),
        forceUpdate: Boolean(source?.forceUpdate),
        storeUrl: trimNullable(source?.storeUrl),
        title: trimNullable(source?.title),
        message: trimNullable(source?.message),
        buttonText: trimNullable(source?.buttonText),
    };
}
export function buildDismissKey(platform, policy) {
    return [
        "cc_app_update_prompt",
        platform,
        policy.recommendedVersion || "",
        policy.minSupportedVersion || "",
        policy.storeUrl || "",
    ].join(":");
}
export function resolveStoreUrl(policy, platform, device) {
    const configuredUrl = trimNullable(policy?.storeUrl);
    if (configuredUrl)
        return configuredUrl;
    if (platform === "android") {
        const applicationId = trimNullable(device?.applicationId);
        if (applicationId) {
            return `market://details?id=${encodeURIComponent(applicationId)}`;
        }
    }
    return null;
}
